import styled from 'styled-components';
import { Link } from 'react-router-dom';

import colors from 'themes/Main';

const { white, gray01, gray03, gray06, blue } = colors;

export const ActionsContainer = styled.div`
  z-index: 20;
  max-width: 200px;
  min-width: 180px;
  border-radius: 5px;
  box-shadow: 0px 4px 5px rgba(215, 220, 230, 0.2),
    0px 3px 14px rgba(215, 220, 230, 0.12),
    0px 8px 10px rgba(215, 220, 230, 0.14);
  background-color: ${white};
  overflow: hidden;
`;

export const ActionsHead = styled.p`
  cursor: default;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${gray03};
  padding: 16px 16px 0;
`;

export const ActionsLink = styled(Link)`
  cursor: pointer;
  display: inline-block;
  width: 100%;
  padding: 8px 16px;
  border-top: 1px solid ${gray06};
  border-bottom: 1px solid ${gray06};
  color: ${gray01};
  font-size: 16px;
  transition: all 0.3s ease-in;
  text-decoration: none;

  &:hover {
    color: ${white};
    background-color: ${blue};
  }

  &:last-child {
    border-bottom: 0;
    margin-bottom: 16px;
  }
`;

export const ActionsButton = styled.button`
  width: 100%;
  display: block;
  padding: 8px 16px;
  border: 0;
  border-top: 1px solid ${gray06};
  border-bottom: 1px solid ${gray06};
  color: ${gray01};
  font-size: 16px;
  transition: all 0.3s ease-in;
  background-color: transparent;
  text-align: left;

  &:disabled {
    color: ${gray03};
    opacity: 0.4;
  }

  &:hover {
    color: ${white};
    background-color: ${blue};
  }

  &:last-child {
    border-bottom: 0;
    margin-bottom: 16px;
  }
`;
